/**
 * 判断是否为手机浏览器
 * @returns {boolean} 是手机返回true，否则false
 */
export function isMobile() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  // 匹配常见移动设备关键词（覆盖安卓、iOS、平板等）
  const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad', 'ipod', 'ios', 'windows phone'];
  return mobileKeywords.some(keyword => userAgent.includes(keyword));
}

/**
 * 判断是否为电脑浏览器
 * @returns {boolean} 是电脑返回true，否则false
 */
export function isPC() {
  return !isMobile();
}


// WEBPACK FOOTER //
// ./src/common/utils/device.js